import { render, staticRenderFns } from "./AdminBilling.vue?vue&type=template&id=8e2aef92&scoped=true"
import script from "./AdminBilling.vue?vue&type=script&lang=js"
export * from "./AdminBilling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2aef92",
  null
  
)

export default component.exports